import { cx } from '@growup/ui';
import { useState } from 'react';

import { AwardsView } from './AwardsView';
import { HallOfFameView } from './HallOfFameView';

type Kind = 'recebidos' | 'hall-of-fame';

const KINDS: { id: Kind; label: string; hint: string }[] = [
  {
    id: 'recebidos',
    label: 'Recebidos',
    hint: 'Prémios que a Grow uP recebeu (growup.gg/premios)',
  },
  {
    id: 'hall-of-fame',
    label: 'Hall of Fame',
    hint: 'Prémios que a Grow uP dá aos membros (growup.gg/hall-of-fame)',
  },
];

/**
 * Conteudos > Premios (combinado entre as propostas Awards e Hall of Fame,
 * 19-10-2026): os premios que a associacao recebeu e os que da, num so ecra
 * com dois separadores. Sao listas e paginas diferentes.
 */
export function PrizesSection() {
  const [kind, setKind] = useState<Kind>('recebidos');
  return (
    <div className="flex flex-col gap-4">
      <div role="tablist" aria-label="Prémios" className="flex flex-wrap">
        {KINDS.map((k) => (
          <button
            key={k.id}
            type="button"
            role="tab"
            aria-selected={kind === k.id}
            title={k.hint}
            onClick={() => setKind(k.id)}
            className={cx(
              '-ml-0.5 border-2 border-gu-line px-4 py-2 font-sub text-label font-bold uppercase first:ml-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gu-focus',
              kind === k.id
                ? 'relative z-10 border-gu-ink bg-gu-ink text-gu-ground'
                : 'text-gu-ink-muted hover:text-gu-ink',
            )}
          >
            {k.label}
          </button>
        ))}
      </div>
      {kind === 'recebidos' ? <AwardsView /> : <HallOfFameView />}
    </div>
  );
}
